/* import __COLOCATED_TEMPLATE__ from './index.hbs'; */
import Component from '@glimmer/component';
import { action } from '@ember/object';
import type ModalService from 'walden-fast/services/modal';
import { service } from '@ember/service';

export interface ActivateServiceBannerSignature {
  // Any blocks yielded by the component
  Blocks: {
    default: [];
  };
  // The element to which `...attributes` is applied in the component template
  Element: null;
}

export default class ActivateServiceBannerComponent extends Component<ActivateServiceBannerSignature> {
  @service('modal') declare modal: ModalService;

  @action
  openModal() {
    this.modal.open('activate-service');
  }
}
